import React, { useEffect, useState } from 'react';

import { Button, Card, Col, notification, Row, Spin } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from 'src/hooks';
import styles from '../Services.module.css';
import { AppI, CommonI, ProductsI, getProductsByZoneId, setCurrentProduct, setCurrentService, setProdCart } from 'src/redux';

import homeI18n from 'src/i18n/home.i18n.json';
import servInfI18n from 'src/i18n/serviceinfo.i18n.json';
import notifI18n from 'src/i18n/notifications.i18n.json';
import { formatter, getSellPriceByLocale } from 'src/utils';

const Detail = () => {
   const { id } = useParams();
   const { currentService, services, products, productsIsFetching, currentZone } = useAppSelector(({ common }: { common: CommonI }) => common);
   const { lang, locale } = useAppSelector(({ app }: { app: AppI }) => app);
   const dispatch = useAppDispatch();
   const navigate = useNavigate();
   const [api, contextHolder] = notification.useNotification();

   const [typeService, setTypeService] = useState<'premium' | 'estandar'>('premium');
   const [serviceSelected, setServiceSelected] = useState<undefined | ProductsI>(undefined);
   const [width, setWidth] = useState(window.innerWidth);
   // get producs
   const getProducts = () => {
      dispatch(getProductsByZoneId(String(currentZone.id)));
   };
   // resize event
   useEffect(() => {
      window.addEventListener('resize', () => {
         setWidth(window.innerWidth);
      });
      return () => window.removeEventListener('resize', () => {});
   }, []);
   // map services and set service selected for get service info
   useEffect(() => {
      if (services && services.length > 0) {
         if (currentService) {
            const serviceFiltered: Array<ProductsI> = services.filter((i: ProductsI) => Number(i.id) === Number(currentService));
            setServiceSelected(serviceFiltered.length > 0 ? serviceFiltered[0] : undefined);
            serviceFiltered.length > 0
               ? setTypeService(serviceFiltered[0].name[lang].toLowerCase().indexOf('premium') > -1 ? 'premium' : 'estandar')
               : setTypeService('estandar');
         } else {
            if (id) {
               const serviceFiltered: Array<ProductsI> = services.filter((i: ProductsI) => Number(i.id) === Number(id));
               setServiceSelected(serviceFiltered.length > 0 ? serviceFiltered[0] : undefined);
               serviceFiltered.length > 0
                  ? setTypeService(serviceFiltered[0].name[lang].toLowerCase().indexOf('premium') > -1 ? 'premium' : 'estandar')
                  : setTypeService('estandar');
            }
         }
      }
   }, [services, currentService]);
   // get products when id or service change
   useEffect(() => {
      if (currentService || id) {
         getProducts();
      }
   }, [currentService, id, locale]);
   // set current servixe
   useEffect(() => {
      if (currentService) {
         // setService(currentService);
         if (currentService !== id) dispatch(setCurrentService(currentService));
      } else {
         if (id && currentService !== id) {
            // setService(id);
            dispatch(setCurrentService(id));
         }
      }
   }, [currentService, id]);

   useEffect(() => {
      if (currentZone.locality === '') navigate('/', { replace: true });
   }, [currentZone.locality]);

   return (
      <>
         {contextHolder}
         <div className={styles.services}>
            <div className='container text-center pt-2 pb-5'>
               <Button type='primary' style={{ width: '40%', marginBottom: 20 }} onClick={() => navigate('/', { replace: true })}>
                  {servInfI18n[lang].btnBuying}
               </Button>
               <div>
                  <h2>{`${serviceSelected?.name[lang]} `}</h2>
               </div>
               <Spin spinning={productsIsFetching} size='large'>
                  <Row gutter={[5, 15]}>
                     {products.length > 0 ? (
                        <>
                           {products
                              .filter((i: ProductsI) => Number(i.category_id) === Number(currentService || id))
                              .map((item: ProductsI, index) => (
                                 <Col
                                    key={index}
                                    xs={24}
                                    sm={24}
                                    md={12}
                                    lg={products.length < 3 ? 12 : 8}
                                    xl={products.length < 3 ? 12 : 8}
                                    xxl={products.length < 3 ? 12 : 8}
                                    style={{ display: 'flex', justifyContent: 'center' }}>
                                    <Card
                                       style={{ width: width < 768 ? (width < 360 ? 300 : 345) : products.length < 3 ? 400 : '90%' }}
                                       hoverable
                                       cover={
                                          <img
                                             style={{ objectFit: 'cover' }}
                                             alt={`img-${serviceSelected ? serviceSelected?.name[lang].toLowerCase() : 'example'}-${index + 1}`}
                                             width={'100%'}
                                             height={300}
                                             src={item.photo}
                                          />
                                       }>
                                       <h4 style={{ textAlign: 'left' }}>{item.name[lang]}</h4>
                                       <p style={{ textAlign: 'right' }}>
                                          {formatter(locale).format(item[getSellPriceByLocale(locale)]).replace('MX', '')}
                                       </p>
                                       <Button
                                          size='large'
                                          style={{ width: '100%', marginBottom: 10 }}
                                          type='primary'
                                          onClick={() => {
                                             dispatch(setCurrentProduct(item));
                                             navigate(
                                                `detalle/${item.id}?title=${serviceSelected ? serviceSelected?.name[lang].toLowerCase() : 'none'}`
                                             );
                                          }}>
                                          {servInfI18n[lang].btnDetail}
                                       </Button>
                                       <Button
                                          size='large'
                                          style={{ width: '100%', marginBottom: 10 }}
                                          type='primary'
                                          onClick={() => {
                                             api.success({
                                                message: notifI18n[lang].serviceTitleNotification,
                                                description: notifI18n[lang].serviceDescriptionNotification,
                                                placement: 'topLeft',
                                             });
                                             dispatch(
                                                setProdCart({
                                                   id: item.id,
                                                   nameProduct: item.name,
                                                   numberProducts: 1,
                                                   cost: item[getSellPriceByLocale(locale)],
                                                   uri: item.photo,
                                                })
                                             );
                                          }}
                                          ghost>
                                          {servInfI18n[lang].btnBuy}
                                       </Button>
                                    </Card>
                                 </Col>
                              ))}
                        </>
                     ) : (
                        <>
                           <p>{servInfI18n[lang].nothingShow}</p>
                        </>
                     )}
                  </Row>
               </Spin>
               <Button type='primary' style={{ width: '40%', marginTop: 20 }} onClick={() => navigate('/', { replace: true })}>
                  {servInfI18n[lang].btnBuying}
               </Button>
               <p style={{ fontFamily: 'Gotham', fontSize: 14, marginTop: 20 }}>{homeI18n[lang].common}</p>
            </div>
         </div>
      </>
   );
};
export default Detail;
